import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {ApiService} from "../../../../services/api.service";
import {NzModalRef} from "ng-zorro-antd/modal";
import {NzNotificationService} from "ng-zorro-antd/notification";

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent implements OnInit {

  passwordForm: FormGroup;
  $submitting: BehaviorSubject<boolean>;
  showPassword: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(public api: ApiService, public fb: FormBuilder, public modal: NzModalRef, public notification: NzNotificationService) {
    this.$submitting = new BehaviorSubject<boolean>(false);
    this.passwordForm = fb.group({
      password: [null, Validators.required],
      new_password: [null, Validators.required],
      new_password_confirmation: [null, Validators.required]
    });
  }

  ngOnInit(): void {
  }

  changePassword(): void{

    this.api.apiPost('/api/user/password', this.passwordForm.value).then((res)=>{
      this.notification.success('Success', 'Your password has been updated');
    }).catch((err)=>{
      this.notification.error('Failed', 'Please check the old password is correct and that the new password matches the old.')
    })

  }

  destroyModal(): void {
    this.modal.destroy();
  }

  getPasswordType(){
    if(this.showPassword.value){
      return 'text';
    }else{
      return 'password';
    }
  }

  togglePassword(){
    if(this.showPassword.value){
      this.showPassword.next(false);
    }else{
      this.showPassword.next(true);
    }
  }

}
